import { ExpedientesService } from './../../services/expedientes.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tpvok',
  templateUrl: './tpvok.component.html',
  styleUrls: ['./tpvok.component.css']
})
export class TpvokComponent implements OnInit {

  constructor(private expedientesService:ExpedientesService) { }

  ngOnInit() {
    console.log( this.expedientesService.ServicioLegalActivo );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tpvok/tpvok.component.ts